import { DataSourceState } from '../../../../types';

export function groupByCompany(dataSources: DataSourceState[]): Map<number, DataSourceState[]> {
    const map = new Map<number, DataSourceState[]>();
    for (const source of dataSources) {
        const group = map.get(source.companyId);
        if (group) {
            group.push(source);
        } else {
            map.set(source.companyId, [source]);
        }
    }
    return map;
}
